<template>
  <v-expansion-panels class="pt-16">
    <v-snackbar
      top
      v-model="snackbar"
      timeout="3000"
      :color="snackbarColor"
      transition="slide-y-transition"
      >{{ snackbarMsg }}</v-snackbar
    >
    <v-expansion-panel>
      <v-expansion-panel-header disable-icon-rotate>
        <h4 class="font-weight-light text-center">
          Did not find you were looking for? Please let us know!
        </h4>
        <template v-slot:actions>
          <v-icon color="sokoDeep">mdi-comment-question</v-icon>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-row justify="center">
          <v-col cols="12" sm="10" md="8" lg="6">
            <v-card ref="form" outlined valid="validForm">
              <v-card-text>
                <v-text-field
                  :rules="[validationRules.required, validationRules.question]"
                  label="Email"
                  required
                  v-model="email"
                >
                </v-text-field>
                <v-textarea
                  :rules="[validationRules.required, validationRules.question]"
                  outlined
                  name="input-7-1"
                  label="Type your question here:"
                  v-model="questionAsked"
                ></v-textarea>
                <v-divider></v-divider>

                <v-item-group multiple v-model="questionTags">
                  <v-subheader>Tags</v-subheader>
                  <v-item
                    class="ma-1"
                    v-for="(tag, i) in tags"
                    :key="i"
                    v-slot:default="{ active, toggle }"
                  >
                    <v-chip
                      active-class="sokoPrimary--text"
                      :input-value="active"
                      @click="toggle"
                    >
                      {{ tag }}
                    </v-chip>
                  </v-item>
                </v-item-group>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  depressed
                  rounded
                  class="sokoDeep white--text mr-5"
                  @click="submitQuery"
                  :loading="loading"
                  >ask</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "AskQuestion",
  data: () => ({
    email: "",
    questionAsked: "",
    questionTags: [],
    loading: false,
    validForm: true,

    snackbar: false,
    snackbarColor: "error",
    snackbarMsg: "Error!",

    validationRules: {
      // form validation rules
      required: (v) => !!v || "Required.",
      question: (v) =>
        (v && v.length <= 50) || "This field cannot exceed 50 characters",
      answer: (v) =>
        (v && v.length <= 150) || "This field cannot exceed 150 characters",
    },
    tags: [
      "Login & Authentication",
      "Scheduling deliveries",
      "Payment",
      "Tracking",
    ],
  }),

  computed: {
    selectedTags() {
      return this.questionTags.map((index) => {
        return this.tags[index];
      });
    },
    userInfo() {
      return this.$store.getters.getCollection("user");
    },
  },

  methods: {
    ...mapActions(["makeFetch"]),

    async submitQuery() {
      this.loading = true;
      const formFields = {
        question: this.questionAsked,
        enquirer: this.email,
        tag: this.selectedTags,
      };
      console.log(formFields); //
      let connError = false;
      console.log("My name");
      const response = await this.makeFetch({
        method: "POST",
        body: formFields,
        addUrl: "/ask-question",
        goTo: "faq",
        withId: false,
        // askQuestion: "askedQuestion",
      }).catch((err) => {
        console.log(err);
        connError = true;
        this.loading = false;
        return false;
      });
      this.isSuccess = response;
      console.log(response);

      if (this.isSuccess) {
        // console.log(connError);
        this.snackbarMsg = "Question successfully sent.";
        this.snackbarColor = "success";
        this.questionAsked = "";
        this.questionTags = [];
      } else {
        if (connError) this.snackbarMsg = "Internet connection problem!";
        else this.snackbarMsg = "Error is submitting question.";
        this.snackbarColor = "error";
      }

      this.loading = false;
      this.validForm = true;
      this.snackbar = true;
    },
  },

  mounted() {
    this.email = this.userInfo.email || "";
  },
};
</script>

<style></style>
